import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {MenuRestriction} from '@emm/core/models/menu-restriction.model';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({
    providedIn: 'root'
})
export class MenuRestrictionsService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {
    }

    getAllRestrictions(): Observable<MenuRestriction[]> {
        return this.http
            .get(`${this.apiUrl}/locations/status`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    };
}
